const state= {
    FmCodeItems:{
        data:[],
        total:0,
    },
    serviceCategories: null,
    properties: null,
    coa: []
};

const getters = {
    FmCodeItems : (state) => state.FmCodeItems,
    serviceCategories: state => state.serviceCategories,
    properties: state => state.properties,
    coa: state => state.coa
};


const actions = {
  async getFmCodeItems({commit}, params){
      return new Promise (( resolve, reject ) => {
          global.axios.get(`api/fm-code`, {params:params})
              .then(response => {
                  commit( 'setFmCodeItems', response.data.data );
                  resolve( response.data.data );
              })
              .catch(error => reject( error ));
      });
  },
  async getActiveItem({commit}, params){
      return new Promise (( resolve, reject ) => {
          global.axios.get(`api/fm-code/active-code`, {params:params})
              .then(response => {
                  resolve( response.data.data );
              })
              .catch(error => reject( error ));
      });
  },
  async getServiceCategories({commit}, params){
      return new Promise((resolve, reject) => {
          global.axios.get(`api/contracts/${params.contractId}/tree-service-categories/${params.categoryId}`)
              .then(response => {
                  if (!params.categoryId) {
                      commit( 'SET_SERVICE_CATEGORIES', response.data.data );
                  }
                  resolve(response.data.data);
              })
              .catch(error => reject(error));
      });
  },
  async getProperties({commit}, params){
      return new Promise((resolve, reject) => {
          global.axios.get(`api/contracts/${params.contractId}/tree-properties/${params.propertyId}`)
              .then(response => {
                if (!params.propertyId) {
                  commit( 'SET_PROPERTIES', response.data.data );
                }
                resolve(response.data.data);
              })
              .catch(error => reject(error));
      });
  },
  async getCOA({commit}, params){
      return new Promise((resolve, reject) => {
          global.axios.get(`api/chart-of-account`, {
            params: params
          })
              .then(response => {
                commit( 'SET_COA', response.data.data );
                resolve(response.data.data);
              })
              .catch(error => reject(error));
      });
  },
  async saveFmCode({commit}, params){

      return new Promise((resolve, reject) => {
        if(params.id){
          global.axios.put(`api/fm-code/` + params.id,{
            property_id: params.property.id,
            service_category_id: params.service_category.id,
            contract_id: params.contract_id,
            fm_code: params.fm_code,
            gl_code: params.coa.gl_code,
            description: params.description,
            gl_account_group: params.gl_account_group,
            is_charge_customer: params.is_charge_customer,
            work_type: params.work_type
          })
          .then(response => {
            resolve(response.data.data);
          })
          .catch(error => reject(error));
        }else{
          global.axios.post(`api/fm-code`,{
            property_id: params.property.id,
            service_category_id: params.service_category.id,
            contract_id: params.contract_id,
            fm_code: params.fm_code,
            gl_code: params.coa.gl_code,
            description: params.description,
            gl_account_group: params.gl_account_group,
            is_charge_customer: params.is_charge_customer,
            work_type: params.work_type
          })
          .then(response => {
            commit( 'CREATE_FM_CODE', response.data.data );
            resolve(response.data.data);
          })
          .catch(error => reject(error));
        }
      });
  },
  async deleteFmCode({commit}, ids) {
    return new Promise((resolve, reject) => {
        global.axios.delete(`api/fm-code`, {
            data: {
                ids: ids
            }
        })
        .then(response => {
            resolve(response);
        })
        .catch(error => reject(error));
    })
  }


}

const mutations = {
    setFmCodeItems (state, data) {
      state.FmCodeItems = data;
    },
    SET_SERVICE_CATEGORIES(state, payload) {
        state.serviceCategories = payload;
    },
    SET_PROPERTIES(state, data){
      state.properties = data;
    },
    SET_COA(state, data){
      state.coa = data.items
    },
    CREATE_FM_CODE(state, data) {
      state.FmCodeItems = [...state.FmCodeItems.items, data];
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
